(function () {
  if (window.Shopify?.designMode) return;
  if (!document.querySelector('.facets')) return;

  const style = document.createElement('style');
  style.textContent = `
    .facets .checkbox__label-text { 
     white-space: normal;
      overflow: visible !important;
      text-overflow: unset !important;
      word-break: break-word;
    }

    .facets label {
      display: flex !important;
      align-items: center !important;
    }

    /* Ausgebucht: nur Text und Checkbox ausgegraut */
    .facets label.antara-ausgebucht {
      position: relative;
    }
    .facets label.antara-ausgebucht input,
    .facets label.antara-ausgebucht .checkbox__label-text {
      opacity: 0.6;
    }

    /* Tooltip – nur Desktop, rechts neben dem Datum */
    @media (min-width: 750px) {
      .facets label.antara-ausgebucht .antara-tooltip {
        display: none;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: calc(100% + 8px);
        background: rgb(240, 238, 244);
        color: #6b648a;
        border-radius: 20px;
        font-size: 13px;
        font-weight: 500;
        padding: 6px 8px;
        white-space: nowrap;
        pointer-events: none;
        z-index: 100;
        opacity: 1;
      }
      .facets label.antara-ausgebucht:hover .antara-tooltip {
        display: inline-block;
      }
    }

    /* Mobile: kein Tooltip */
    @media (max-width: 749px) {
  .facets label.antara-ausgebucht .antara-tooltip {
    display: inline-block !important;
    position: static !important;
    background: rgb(240, 238, 244);
    color: #6b648a;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 500;
    padding: 6px 8px;
    white-space: nowrap;
    opacity: 1 !important;
    margin-left: 8px;
  }
}

  `;
  document.head.appendChild(style);

  async function fetchVariants() {
    const response = await fetch('/products.json?limit=250');
    const data = await response.json();
    const terminMap = {};

    for (const product of data.products) {
      for (const variant of product.variants) {
        const termin = variant.option1 || variant.option2 || variant.option3;
        if (!termin) continue;
        if (!terminMap[termin]) terminMap[termin] = [];
        terminMap[termin].push(variant.available);
      }
    }

    return terminMap;
  }

  async function addBadges() {
    const terminMap = await fetchVariants();

    document.querySelectorAll('.facets label, facet-filters-form label').forEach(label => {
      const text = label.textContent.trim();
      if (!terminMap[text]) return;
      const allSoldOut = terminMap[text].every(a => !a);
      if (allSoldOut && !label.querySelector('.antara-tooltip')) {
        label.classList.add('antara-ausgebucht');
        const tooltip = document.createElement('span');
        tooltip.className = 'antara-tooltip';
        tooltip.textContent = 'ausgebucht';
        label.appendChild(tooltip);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', addBadges);
})();
